const GRNData_1 =[
  {
    orderData: {
      gort_id: "gort id",
      store_id: "store id",
      cmr_id: "customer id",
      cmr_phone_number: "customer phone number",
      remarks: "remarks",
      gort_total_gst: "0.00",
      gort_total_discount: "0.00",
      gort_payment_status: "payment status",
      gort_transaction_id: "transaction id",
      gort_order_status: "order status",
      gort_payment_method: "payment method",
      gort_billing_address: "billing address",
      gort_total_amount: "0.00",
      gort_sub_total: "0.00",
      gort_round_off_value: "0.00",
      gort_delivery_date: "2025-12-31",
      gort_document_date: "2025-12-31",
      cmr_code: "customer code",
      cmr_name: "customer name",
      created_date: "2025-12-31",
      update_date: "2025-12-31",
      inv_no: "invoice number",
      document_date: "2025-12-31",
      tcs_or_tds_amount: "0.00",
      tcs_or_tds_percentage: "0.00",
      tds_tcs_type: "tds/tcs type",
      tcs_or_tds_percentage_id: "tds/tcs id",
      customer_invoice_number: "customer invoice number"
    },
    itemData: [
      {
        gort_id: "gort id",
        item_id: "item id",
        item_code: "item code",
        item_generic_name: "generic name",
        item_name: "product name",
        item_pack_size: "pack size",
        pot_id: "purchase order id",
        item_rack_location: "rack location",
        item_unit_price: "0.00",
        item_quantity: "0.00",
        item_schedule: "schedule",
        item_received_quantity: "0.00",
        item_discount_amount: "0.00",
        item_discount_percentage: "0.00",
        item_tax_amount: "0.00",
        item_return_open_quantity: "0.00",
        item_total_tax_percentage: "0.00",
        item_to_be_received: "0.00",
        item_total_amount: "0.00",
        item_uom: "uom",
        item_uom_id: "uom id",
        item_gst: "0.00",
        item_sgst: "0.00",
        item_cgst: "0.00",
        item_igst: "0.00",
        item_free_quantity: "0.00",
        item_hsn: "hsn code",
        item_manufacturer_id: "manufacturer id",
        item_manufacturer_name: "manufacturer name",
        itemBatchData: [
          {
            item_id: "item id",
            item_batch_number: "batch number",
            item_sellable_quantity: "0",
            item_non_sellable_quantity: "0",
            item_exp_date: "2025-12-31",
            item_mfg_date: "2025-12-31",
            item_batch_free_quantity: "0.00",
            item_batch_unit_price: "0.00",
            item_batch_purchase_rate: "0.00",
            item_batch_discount_percentage: "0.00",
            item_batch_discount_amount: "0.00",
            item_batch_tax_amount: "0.00",
            item_batch_tax_percentage: "0.00",
            item_batch_final_purchase_rate: "0.00",
            item_batch_total_purchase_rate: "0.00",
            to_bin_id: "bin id",
            to_bin_location: "bin location",
            item_batch_total_effective_qauntity: "0.00",
            item_batch_for_qauntity: "0.00",
            item_batch_for_free_qauntity: "0.00",
            item_batch_scheme_discount_percentage: "0.00",
            item_batch_scheme_discount_amount: "0.00",
            item_batch_scheme_purchase_rate: "0.00",
            item_batch_discounted_purchase_rate: "0.00",
            item_batch_taxable_amount: "0.00",
            item_batch_total_base_purchase_rate: "0.00",
            item_batch_gen_discount_amount: "0.00"
          }
        ]
      }
    ]
  }
];
const GRNTaxInfoData_1 = [
  {
    item_gst: "GST rate",
    taxable: "0.00",       
    gst: "0.00",           
    sgst: "0.00",          
    igst: "0.00"           
  },
  {
    item_gst: "Another GST rate",
    taxable: "0.00",
    gst: "0.00",
    sgst: "0.00",
    igst: "0.00"
  }
];

const storeDetailsResult_sample = [
  {
    company: "DAVA INDIA",
    company_address: "BENGULURU",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_20_20B",
    dl_no_21_21b: "DRUG_LICENSE_21_21B",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default { GRNData_1,storeDetailsResult_sample };
